<template>
  <div class="container">
    <div class="section">
      <title-bar title="Capacitaciones"/>
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="has-text-centered">
            No hay información
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
export default {
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue')
  },
  mixins: [mixins],
  data () {
    return {
      loading: true,
      menu: []

    }
  },
  methods: {
    ...mapActions([])
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany.financialCompany
    })
  },
  created () {

  }

}
</script>

<style lang="scss" scoped>
.section {
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
h3 {
  font-size: 1.1rem !important;
  margin-top: 1rem;
  color: #484c53;
  font-weight: 600;
  padding-left: 0.5rem;
}
.is-flex {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  border: 1px solid #EBECED;
  border-radius: 0.25rem;
  padding: 1.5rem;
  color: #484c53;
  .label {
    font-size: 13px;
  }
  .value {
    font-size: 14px;
  }
}
.is-flex-action {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  border: 1px solid #EBECED;
  border-radius: 0.25rem;
  padding: 1.5rem;
  color: #484c53;
  .label {
    font-size: 13px;
  }
  .value {
    font-size: 14px;
  }
  .change-password {
    font-size: 12px;
    color: #4c70ff;
    font-weight: 600;
    cursor: pointer;
  }
}
.mt-4 {
  margin-top: 1rem;
}
</style>
